(function() { module.exports = window["wp"]["editPost"]; }());